import Media from './Media.vue'

export default Media
